import type { Competitor } from '../../../../../bridge/types/competitors.ts';

// Single source of truth for "does this competitor have any real research
// behind it?" Name and website_url are deliberately excluded: a card seeded
// with only a name/URL is not yet substantive. Both the tab (render filter)
// and the research hook (failed-research detection) check the same predicate.
export function hasSubstantiveData(c: Competitor): boolean {
	return !!(
		c.description ||
		c.logo_url ||
		c.address ||
		c.phone ||
		c.email ||
		c.founded_year ||
		c.employee_count ||
		c.hours_of_operation ||
		c.notes ||
		(c.strengths && c.strengths.length > 0) ||
		(c.weaknesses && c.weaknesses.length > 0) ||
		(c.differentiators && c.differentiators.length > 0) ||
		c.social_media ||
		c.reviews ||
		c.website_seo ||
		(c.products && c.products.length > 0)
	);
}
